module.exports = __webpack_public_path__ + "static/no-webcam-filler--white-acb5166147eda070e37d20825ad0ad95.svg";